import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FilePictoProps extends pictoProps {
}

export interface FilePictoState extends pictoState {
}

export class FilePicto extends Picto<FilePictoProps,FilePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.filePicto;        
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FilePicto);
